import { render, staticRenderFns } from "./imgM.vue?vue&type=template&id=d30feda4"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d30feda4')) {
      api.createRecord('d30feda4', component.options)
    } else {
      api.reload('d30feda4', component.options)
    }
    module.hot.accept("./imgM.vue?vue&type=template&id=d30feda4", function () {
      api.rerender('d30feda4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgM.vue"
export default component.exports